import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Breadcrumb, Table } from '../../common/components';
import { getUsers } from '../../user/services/user.service';
import CompanyTabsComponent from './companyTabs.container';

const TABLE_CONFIG = {
  columns: [
    {
      caption: 'Imię i nazwisko',
      dataField: 'name',
    },
    {
      caption: 'Email',
      dataField: 'email',
    },
    {
      caption: 'Aktywny',
      dataField: 'active',
      renderCell: (active) => (active ? 'Tak' : 'Nie'),
    },
  ],
  noItemsFoundText: 'Brak użytkowników',
  filterFields: 'name,email',
  initialSort: {
    sortField: 'name',
    sortDirection: 'asc',
  },
};

class CompanyDetailsUsers extends PureComponent {
  state = {
    data: [],
    totalCount: 0,
    isLoading: true,
  };

  id = this.props.match.params.id;

  getData = async (params) => {
    this.setState({
      isLoading: true,
    });

    const dataTable = await getUsers(
      Object.assign(params, { company: this.id }),
    );

    this.setState({
      data: dataTable.data,
      totalCount: dataTable.totalCount,
      isLoading: false,
    });
  };

  addUserToCompany = () => {
    const { history } = this.props;

    history.push(`/user?company=${this.id}`);
  };

  onRowClick = (ev) => {
    const {
      currentTarget: { id },
    } = ev;
    const { history } = this.props;

    history.push(`/user-details/${id}`);
  };

  render() {
    const { data, isLoading, totalCount } = this.state;

    return (
      <>
        <Breadcrumb title="Lista użytkowników">
          <div className="row no-gutters justify-content-end py-3">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={this.addUserToCompany}
            >
              Dodaj użytkownika
            </button>
          </div>
        </Breadcrumb>
        <div className="content">
          <CompanyTabsComponent active="users" />
          <Table
            config={TABLE_CONFIG}
            items={data}
            fetchData={this.getData}
            totalCount={totalCount}
            isLoading={isLoading}
            onRowClick={this.onRowClick}
            pagination
          />
        </div>
      </>
    );
  }
}

CompanyDetailsUsers.propTypes = {
  match: PropTypes.objectOf(PropTypes.shape).isRequired,
  history: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default withRouter(CompanyDetailsUsers);
